import axios from 'axios'
import i18n from '@/i18n'
import auth from '@/plugins/msal'

// 环境的切换
axios.defaults.baseURL = process.env.VUE_APP_WEB_API
axios.defaults.timeout = 300000
axios.defaults.withCredentials = true
axios.defaults.responseType = 'json'
/***解决IE11存在缓存get请求的问题***/
axios.defaults.headers.get['Cache-Control'] = 'no-cache'

// 请求拦截器
axios.interceptors.request.use(
  async (config) => {
    try {
      const token = await auth.getAccessToken()
      if (token) {
        config.headers.Authorization = 'Bearer ' + token
      }
    } catch (e) {
      // Leave request without token; API will reject if auth is required.
    }
    return config
  },
  (error) => {
    var originalRequest = error.config
    if (
      error.code == 'ECONNABORTED' &&
      error.message.indexOf('timeout') != -1 &&
      !originalRequest._retry
    ) {
      error.response = i18n.t('applytimeout')
    }
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  (error) => {
    if (error.response != undefined) {
      if (error.response.status) {
        switch (error.response.status) {
          case 400:
            error.response.data.error = { message: 'Bad request' }
            break
          case 500:
            break
          // 其他错误，直接抛出错误提示
          default:
          // error.response = i18n.t('neterrormsg')
        }
        return Promise.reject(error.response)
      }
    } else {
      return Promise.reject(error.message)
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  if (params != undefined && params != null) {
    params.t = new Date().getTime()
  } else {
    params = { t: new Date().getTime() }
  }

  // params needs to be passed this way!!!
  return axios.get(url, { params })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return axios.post(url, params)
}
